var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-popup/u-popup" */ "@/uni_modules/uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uLine: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-line/u-line" */ "@/uni_modules/uview-ui/components/u-line/u-line.vue"
      )
    },
    uLoadingIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-loading-icon/u-loading-icon" */ "@/uni_modules/uview-ui/components/u-loading-icon/u-loading-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var a0 = {
    borderRadius: "6px",
    overflow: "hidden",
    marginTop: "-" + _vm.$u.addUnit(_vm.negativeTop),
  }
  var g0 = _vm.$u.addUnit(_vm.width)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        a0: a0,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }